<script>
import appConfig from '@src/app.config'
import { loadStripe } from '@stripe/stripe-js';

import { CommunicationsTable } from 'coryallen-communications';

export default {
  props: ['cart', 'preload_listing'],
  components: { CommunicationsTable },
  data() {
    return {
      dsbl_btn: false,

      stripe: {},
      cardNumber: {},
      cardExpiry: {},
      cardCvc: {},
      agree_terms: false,
      not_refundable: false,

      packageKey: '',

      loading_listing: false,
      listing: {
        active_package: {},
        active_services: [],
      },

      loading_packages: true,
      packages: [],

      loading_services: true,
      services: [],

      selected_package: {},
      selected_service: {},

      tabIndex: 0,

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.cart.id,
        onable_type: 'coryallen\\Carts\\Models\\Cart',
        // byable_id: this.$route.params.id,
        // byable_type: 'App\\User',
      },
    }
  },
  computed: {
    computedPackages: function() {
      var found = false;
      return JSON.parse(JSON.stringify(this.packages)).filter(b => {
        // Hide active_package and any packages less than it
        if(this.listing.active_package && this.listing.active_package.id){
          if(b.id == this.listing.active_package.id) { found = true; return false; }
          return found;
        }
        return true;
      }).map(b => {
        // Subtract packages_total from package prices
        if(this.listing.packages_total && parseFloat(this.listing.packages_total) > 0) {
          b.price = (!(parseFloat(b.price) - parseFloat(this.listing.packages_total) > 0) ? 0 : parseFloat(b.price) - parseFloat(this.listing.packages_total));
        }
        // Adjust package price if upcharge by zip code
        for(var i in b.upcharges) {
          if(this.listing.PostalCode && b.upcharges[i].zip_code == this.listing.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        return b
      });
    },
    used_services: function() {
      var results = [], used = [];
      if(this.computedPackages) { for(var i in this.computedPackages) {
        var services = [];
        if(this.computedPackages[i].services) { for(var j in this.computedPackages[i].services) {
          if(used.includes(this.computedPackages[i].services[j].id)) {
            services.push(this.computedPackages[i].services[j].id);
          } else {
            used.push(this.computedPackages[i].services[j].id);
          }
        } }
        results.push(services);
      } }
      return results;
    },
    additionalServices: function () {
      return JSON.parse(JSON.stringify(this.services)).filter(b => {
        // Check if additional service
        if(!b.additional) { return false; }

        // Check if purchased before and is a once service.
        if(b.once) {
          if(this.cart.package.services) { for(var i in this.cart.package.services) {
            if(this.cart.package.services[i].id == b.id) { return false; }
          } }
          if(this.listing.active_package && this.listing.active_package.services) { for(var i in this.listing.active_package.services) {
            if(this.listing.active_package.services[i].id == b.id) { return false; }
          } }
          if(this.listing.active_services) { for(var i in this.listing.active_services) {
            if(this.listing.active_services[i].id == b.id) { return false; }
          } }
        }

        return true;
      }).map(b => {
        b.active = false;
        for(var i in b.upcharges) {
          if(this.listing.PostalCode && b.upcharges[i].PostalCode == this.listing.PostalCode && b.upcharges[i].active == "1"){ b.price = parseFloat(b.price) + parseFloat(b.upcharges[i].upcharge); break; }
        }
        return b
      });
    },
    computedTotal: function() {
      var total = 0;
      if(parseFloat(this.cart.package.price) > 0) {
        total = total + parseFloat(this.cart.package.price);
      }
      if(this.cart.services.length > 0) { for(var i in this.cart.services) {
        if(parseFloat(this.cart.services[i].price) > 0) {
          var service_price = (this.cart.services[i].quantity ? parseFloat(this.cart.services[i].price)*parseInt(this.cart.services[i].quantity) : parseFloat(this.cart.services[i].price));
          total = total + service_price;
        }
      } }
      this.cart.sub_total = total;
      this.cart.total = (total - this.cart.discount_total > 0 ? total - this.cart.discount_total : 0);
      return (total - this.cart.discount_total > 0 ? total - this.cart.discount_total : 0);
    },
  },
  async mounted() {
    this.stripe = await loadStripe(appConfig.stripe_key);
    const elements = this.stripe.elements();

    this.cardNumber = elements.create('cardNumber');
    this.cardNumber.mount('#card-number');

    this.cardExpiry = elements.create('cardExpiry');
    this.cardExpiry.mount('#card-expiry');

    this.cardCvc = elements.create('cardCvc');
    this.cardCvc.mount('#card-cvc');
  },
  created() {
    if(this.cart.due_date) { this.cart.due_date = this.moment(this.cart.due_date).format('YYYY-MM-DD'); }

    this.fetch_packages();
    this.fetch_services();

    if(this.preload_listing.id) {
      this.listing = this.preload_listing;
    } else {
      this.fetch_listing();
    }
  },
  methods: {
    fetch_packages() {
      this.loading_packages = true;
      this.$http.get('/api/packages/fetch', {params: {paginate: 1000, page: 1, total: 0, wheres: {status: 1}}}).then(res => {
        // console.log(res);
        this.packages = res.data.data
        this.loading_packages = false;
      }).catch(res => { this.loading_packages = false; this.popupErrors(res); });
    },
    fetch_services() {
      this.loading_services = true;
      this.$http.get('/api/services/fetch', {params: {paginate: 1000, page: 1, total: 0, wheres: {status: 1}}}).then(res => {
        // console.log(res);
        this.services = res.data.data;
        this.loading_services = false;
      }).catch(res => { this.loading_services = false; this.popupErrors(res); });
    },
    fetch_listing() {
      this.loading_listing = true;
      this.$http.get('/api/listings/fetch', {params: {paginate: 1000, page: 1, total: 0, wheres: {id: this.cart.listing_id}}}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.listing = res.data.data[0];
        }
        this.loading_listing = false;
      }).catch(res => { this.loading_listing = false; this.popupErrors(res); });
    },
    add_service() {
      if(this.selected_service.id) {
        var new_service = {
          id: this.selected_service.id,
          title: this.selected_service.title,
          description: this.selected_service.description,
          price: parseFloat(this.selected_service.price),
          quantity: 1,
          once: this.selected_service.once,
        };
        this.cart.services.push(new_service);
      }
      this.selected_service = {};
    },
    delete_service(index) {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Remove this item from the cart?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.cart.services.splice(index, 1);
            this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
            n.close();
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    add_package() {
      if(this.selected_package.id) {
        var new_package = {
          id: this.selected_package.id,
          title: this.selected_package.title,
          services: [],
          price: parseFloat(this.selected_package.price),
          quantity: 1,
        };
        for(var i in this.selected_package.services) {
          new_package.services.push({
            id : this.selected_package.services[i].id,
            title : this.selected_package.services[i].title,
            description : this.selected_package.services[i].description,
          });
        }
        this.cart.package = new_package;
      }
      this.selected_package = {};
    },
    delete_package() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Remove this item from the cart?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.cart.package = {};
            this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
            n.close();
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    create_cart() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      this.$http.post('/api/carts/store', this.cart).then(res => {
        // console.log(res);
        if(res.data.id) {
          this.cart.id = res.data.id;
          this.cart.user_id = res.data.user_id;
          this.cart.status = res.data.status;
          this.cart.cart_hash = res.data.cart_hash;
          this.communications_filters.onable_id = this.cart.id;
          this.$noty.success("Cart draft has been created.");
        } else {
          this.$noty.error("There was an issue creating the cart. Please make note of the information you entered and refresh the page.");
        }
        this.$emit('fetchdata');
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    save_cart() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/carts/save', this.cart).then(res => {
        console.log(res);
        this.$noty.success("Changes have been saved.");
        this.$emit('fetchdata');
        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    complete_cart() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.post('/api/carts/complete', this.cart).then(res => {
        console.log(res);
        if(res.data.status) { this.cart.status = res.data.status; }
        if(res.data.payable_date) { this.cart.payable_date = res.data.payable_date; }

        this.$noty.success("Cart has been moved to the payable status.");
        this.$emit('fetchdata');

        this.dsbl_btn = false;
      }).catch(res => { this.dsbl_btn = false; this.popupErrors(res); });
    },
    delete_cart() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.cart.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this content?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/carts/delete/'+this.cart.id).then(res => {
              console.log(res);
              this.$noty.success("Cart has been deleted.");
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$emit('fetchdata');
              this.$emit('closemodal');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    send_invoice() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.cart.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to send this invoice to "+this.cart.to_email+"?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.post('/api/carts/send', this.cart).then(res => {
              // console.log(res);
              if(res.data.send_count) { this.cart.send_count = res.data.send_count; }
              if(res.data.first_issue_date) { this.cart.first_issue_date = res.data.first_issue_date; }
              if(res.data.last_issue_date) { this.cart.last_issue_date = res.data.last_issue_date; }
              this.$noty.success("Invoice has been sent to "+this.cart.to_email+".");
              this.$emit('fetchdata');
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    void_cart() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.cart.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      var randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to void this invoice?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.post('/api/carts/void', this.cart).then(res => {
              // console.log(res);
              this.cart.status = res.data.status;
              this.$noty.success("Invoice has been moved to Void status.");
              this.$emit('fetchdata');
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('NO', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
    async submit_payment() {
      if(this.dsbl_btn == true) { console.log("disabled"); return; } this.dsbl_btn = true;

      // =======================
      if(
        !this.cart.payment_method
      ) {
        this.$noty.error("Please select a payment method.");
        this.dsbl_btn = false; return;
      }

      // =======================
      if(
        !this.agree_terms ||
        !this.not_refundable
      ) {
        this.$noty.error("Before continuing you must agree to our listing agreements.");
        this.dsbl_btn = false; return;
      }

      if(this.cart.payment_method == 'Website admin' && (this.cart.total - this.cart.paid_total > 0)) {
        const {paymentMethod, error} = await this.stripe.createPaymentMethod('card', this.cardNumber, {
          billing_details: {
            name: this.cart.to_name,
            email: this.cart.to_email,
            phone: this.cart.to_phone,
            address: {
              line1: this.cart.to_address,
              city: this.cart.to_city,
              state: this.cart.to_state,
              postal_code: this.cart.to_zip_code
            }
          }
        });
        if(error) {
          console.log(error);
          if(error.message) { this.$noty.error(error.message); }
          else { this.$noty.error(error); }
          this.dsbl_btn = false;
          return;
        }
        this.cart.payment_method_id = paymentMethod.id;
      }
      // console.log(this.cart);
      this.$http.post('/api/carts/pay', this.cart).then(res => {
        // console.log(res);
        this.cart.status = res.data.status;
        this.cart.paid_total = res.data.paid_total;
        this.cart.paid_date = res.data.paid_date;
        this.$noty.success("Invoice payment complete. Thank you for your business.");
        this.$emit('fetchdata'); // This will also trigger a fetchdata on the parent to update the listing.
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },

    // Pay invoice

    // Dev control for deletion?
  }
}
</script>

<template>
  <div>

    <b-tabs v-if="cart.id" class="nav-bordered header-nav hide-content m-0" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading_listing"></span> Invoice</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading_listing"></span> Details</template></b-tab>
    </b-tabs>

    <div v-show="tabIndex == 0">
      <div class="p-3 bg-gray-100">

        <div v-show="loading_listing" class="alert alert-warning"><span class="spinner-border spinner-border-sm" v-if="loading_listing"></span> Loading listing...</div>

        <div v-show="!loading_listing">

          <div class="card-box small border _box-shadow-0-1-4-b-2" :id="'print_invoice'">
            <div class="row">
              <div class="col-sm-8">
                <div class="row">
                  <div class="col-sm-12">
                    <h4 class="mt-0 mb-1 text-black">{{cart.from_name}}</h4>
                    <div class="">{{formatPhone(cart.from_phone)}}</div>
                    <div class="">{{cart.from_email}}</div>
                  </div>
                  <div class="col-sm-6">
                    <h4 class="mt-4 mb-1 text-black">Bill to : </h4>
                    <div class="">{{cart.to_name}}</div>
                    <div class="">{{cart.to_email}}</div>
                    <div class="">{{formatPhone(cart.to_phone)}}</div>
                  </div>
                  <div class="col-sm-6">
                    <h4 class="mt-4 mb-1 text-black">Property : </h4>
                    <div class="">{{cart.for_address}}</div>
                    <div class="">{{cart.for_city}}, {{cart.for_state}} {{cart.for_zip_code}}</div>
                  </div>
                </div>
              </div>
              <div class="col-sm-4 text-right">
                <h4 class="mt-0 mb-3 text-black">Invoice</h4>
                <table class="table table-borderless table-centered m-0">
                  <tbody>
                    <tr>
                      <th class="p-1">Date issued : </th>
                      <td class="p-0 text-right _w-150">{{ cart.payable_date ? moment(cart.payable_date).format('MM/DD/YYYY') : '' }}</td>
                    </tr>
                    <tr>
                      <th class="p-1">Date due : </th>
                      <td class="p-0 text-right">
                        <input v-if="cart.status == 1" type="date" class="form-control border _h-30 _h-n-auto _w-140 p-1 ml-auto" v-model="cart.due_date"></input>
                        <div v-else class="">{{ cart.due_date ? moment(cart.due_date).format('MM/DD/YYYY') : '' }}</div>
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">Cart status : </th>
                      <td class="p-0 text-right">
                        <span class="badge border-0 py-1 px-3" :class="
                          (cart.status == 0 ? 'badge-danger' :
                          cart.status == 1 ? 'badge-purple' :
                          cart.status == 2 ? 'badge-warning' :
                          cart.status == 3 ? 'badge-success' :
                          'badge-light')
                        ">
                          {{(cart.status == 0 ? 'Void' :
                            cart.status == 1 ? 'Draft' :
                            cart.status == 2 ? 'Payable' :
                            cart.status == 3 ? 'Paid' :
                            'Unknown')}}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th class="p-1">Order number : </th>
                      <td class="p-0 text-right">{{cart.id}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <textarea v-if="cart.status == 1" class="form-control border p-1" rows="3" v-model="cart.intro"></textarea>
                <div v-else-if="cart.intro" class="text-pre-wrap">{{cart.intro}}</div>
              </div>
              <div class="col-sm-6 text-right">

              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-responsive">
                  <table class="table border-bottom border-light mt-4">
                    <thead>
                      <tr>
                        <th v-if="cart.status == 1" style="width: 1%" class="border-light"></th>
                        <th class="border-light">Item</th>
                        <th style="width: 10%" class="border-light">Quantity</th>
                        <th style="width: 10%" class="border-light">Unit price</th>
                        <th style="width: 10%" class="border-light text-right">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-if="cart.package && Object.keys(cart.package).length">
                        <td v-if="cart.status == 1" class="border-light"><button v-if="cart.package.id" type="button" class="btn btn-white p-0 border-0 text-hover-danger" @click="delete_package()"><Icon icon="ri:delete-bin-7-line" v-tippy content="Delete" /></button></td>
                        <td class="border-light">
                          <div class="font-weight-bold text-black">{{cart.package.title}} Package</div>
                          <p v-for="(pack_serv, pack_serv_i) in cart.package.services" :key="'a'+pack_serv_i" class="m-0 small">{{pack_serv.title}}</p>
                          <textarea v-if="cart.status == 1" class="form-control border p-1 mt-1 text-muted _f-s-12" rows="1" placeholder="Notes for this line item..." v-model="cart.package.notes"></textarea>
                          <div v-else-if="cart.package.notes" class="_f-s-12 text-muted border-top border-light mt-1 pt-1 text-pre-wrap">{{cart.package.notes}}</div>
                        </td>
                        <td class="border-light">1</td>
                        <td class="border-light">
                          <w-money v-if="cart.status == 1" class="form-control border p-1 _h-30 _h-n-auto" v-model="cart.package.price"></w-money>
                          <div v-else class="">{{formatPrice(cart.package.price)}}</div>
                        </td>
                        <td class="border-light text-right">{{formatPrice(cart.package.price * (cart.package.quantity ? cart.package.quantity : 1))}}</td>
                      </tr>
                      <tr v-if="!cart.package.id && cart.status == 1">
                        <td class="border-light"></td>
                        <td class="border-light position-relative">
                          <b-form v-if="computedPackages" class="input-group my-group" @submit.prevent="add_package">
                            <span v-show="loading_packages" class="position-absolute _pos-t-12 _pos-l-12 spinner-border spinner-border-sm _z-100"></span>
                            <select class="form-control border px-1" v-model="selected_package">
                              <option v-for="(pack, pack_i) in computedPackages" :key="pack.id" :value="pack">{{pack.title}}</option>
                            </select>
                            <span class="input-group-btn">
                              <button type="submit" class="btn btn-white border _f-s-11 px-1 _b-r-tl-0 _b-r-bl-0 _w-100"><Icon icon="ri:add-line" /> Add package</button>
                            </span>
                          </b-form>
                        </td>
                        <td class="border-light"></td>
                        <td class="border-light"></td>
                        <td class="border-light"></td>
                      </tr>
                      <tr v-for="(serv, serv_i) in cart.services" :key="'b'+serv_i">
                        <td v-if="cart.status == 1" class="border-light">
                          <button type="button" class="btn btn-white p-0 border-0 text-hover-danger" @click="delete_service(serv_i)"><Icon icon="ri:delete-bin-7-line" v-tippy content="Delete" /></button>
                        </td>
                        <td class="border-light">
                          <div class="font-weight-bold text-black">{{serv.title}}</div>
                          <textarea v-if="cart.status == 1" class="form-control border p-1 mt-1 text-muted _f-s-12" rows="1" placeholder="Notes for this line item..." v-model="serv.notes"></textarea>
                          <div v-else-if="serv.notes" class="_f-s-12 text-muted border-top border-light mt-1 pt-1 text-pre-wrap">{{serv.notes}}</div>
                        </td>
                        <td class="border-light">
                          <input v-if="cart.status == 1" type="number" class="form-control border p-1 _h-30 _h-n-auto" min="0" step="any" v-model="serv.quantity">
                          <div v-else>{{(serv.quantity ? serv.quantity : '1')}}</div>
                        </td>
                        <td class="border-light">
                          <w-money v-if="cart.status == 1" class="form-control border p-1 _h-30 _h-n-auto" v-model="serv.price"></w-money>
                          <div v-else>{{formatPrice(serv.price)}}</div>
                        </td>
                        <td class="border-light text-right">{{formatPrice(serv.price * (serv.quantity ? serv.quantity : 1))}}</td>
                      </tr>
                      <tr v-if="cart.status == 1">
                        <td class="border-light"></td>
                        <td class="border-light">
                          <b-form v-if="additionalServices" class="input-group my-group" @submit.prevent="add_service">
                            <span v-show="loading_services" class="position-absolute _pos-t-12 _pos-l-12 spinner-border spinner-border-sm _z-100"></span>
                            <select class="form-control border px-1" v-model="selected_service">
                              <option v-for="(service, service_i) in this.additionalServices" :key="service.id" :value="service">{{service.title}}</option>
                            </select>
                            <span class="input-group-btn">
                              <button type="submit" class="btn btn-white border _f-s-11 px-1 _b-r-tl-0 _b-r-bl-0 _w-100"><Icon icon="ri:add-line" /> Add service</button>
                            </span>
                          </b-form>
                        </td>
                        <td class="border-light"></td>
                        <td class="border-light"></td>
                        <td class="border-light"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="clearfix pt-5">
                  <textarea v-if="cart.status == 1" class="form-control border p-1 small" rows="4" v-model="cart.outro"></textarea>
                  <div v-else-if="cart.outro" class="text-pre-wrap small">{{cart.outro}}</div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="float-right">
                  <div class="py-1">
                    <span class="font-weight-bold text-black">Subtotal : </span> <span class="float-right ml-4">{{formatPrice(cart.sub_total)}}</span>
                  </div>
                  <div v-if="cart.status == 1 || cart.discount_total > 0">
                    <!-- <div class="py-1" v-if="cart.status == 1">
                      <b>Discount : </b><span class="float-right ml-4"><w-money class="form-control border p-1 _h-30 _w-140 text-right" v-model="cart.discount_total"></w-money></span>
                    </div> -->
                    <div class="py-1" v-if="cart.status != 1 && cart.discount_total > 0">
                      <b>Discount : </b><span class="float-right ml-4">-{{formatPrice(cart.discount_total)}}</span>
                    </div>
                  </div>
                  <div class="font-weight-bold text-black py-1">Total : <span class="float-right ml-4">{{formatPrice(computedTotal)}}</span></div>
                  <div class="py-1" v-if="cart.paid_total > 0">
                    <b>Amount paid : </b><span class="float-right ml-4">-{{formatPrice(cart.paid_total)}}</span>
                  </div>
                  <div class="py-1" v-if="cart.paid_total > 0">
                    <b>Amount due : </b><span class="float-right ml-4">{{formatPrice(cart.total - cart.paid_total)}}</span>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>
              <div v-if="cart.cart_hash || cart.listing_id" class="col-sm-12 small pt-3">
                <div v-if="cart.cart_hash" class="small">
                  <strong>Invoice URL:</strong> <a :href="app_url+'/invoice/'+cart.cart_hash" target="_blank">{{app_url+'/invoice/'+cart.cart_hash}}</a>
                </div>
                <div v-if="cart.listing_id" class="small">
                  <strong>Listing URL:</strong> <a :href="app_url+'/my-listings/'+cart.listing_id" target="_blank">{{app_url+'/my-listings/'+cart.listing_id}}</a>
                </div>
              </div>
            </div>
          </div>

          <div v-show="cart.status == 2" class="card-box small border _box-shadow-0-1-4-b-2">

            <div class="">
              <div class="form-group">
                <label for="input-payment_method">Payment method : </label>
                <select id="input-payment_method" name="payment_method" class="form-control" v-model="cart.payment_method" required>
                  <option value="Website admin">Pay now</option>
                  <option value="Cash">Cash</option>
                  <option value="Check">Check</option>
                  <option value="Stripe admin">Stripe invoice</option>
                  <option value="Other">Other</option>
                </select>
              </div>
              <div v-if="cart.payment_method == 'Other'" class="form-group">
                <label for="input-payment_method_other">Other payment method : </label>
                <input id="input-payment_method_other" name="payment_method_other" type="text" class="form-control" v-model="cart.payment_method_other" required>
              </div>
              <div v-if="cart.payment_method != 'Website admin'" class="form-group">
                <label for="input-paid_date">Payment date : </label>
                <input id="input-paid_date" name="paid_date" type="datetime-local" class="form-control" v-model="cart.paid_date">
              </div>
            </div>
            <div v-show="cart.payment_method == 'Website admin' && computedTotal > 0 && !cart.prevent_payment" class="border-top border-light mt-3 mb-0 pt-3">
              <div class="row">
                <div class="col-sm _w-m-250 border-right border-light">
                  <h5 class="mb-3">Enter payment information</h5>
                  <small class="text-muted">Processed securely through <a href="https://stripe.com/" target="_blank">Stripe</a>.</small>
                  <img src="@assets/images/stripe-payment-logo.png" class="_w-m-150 mt-1">
                </div>
                <div class="col-sm">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="field-BillingName">Name on card <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                        <input id="field-BillingName" name="address" type="text" class="form-control" v-model="cart.to_name" required>
                        <small class="text-muted"></small>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label for="field-to_address">Billing address <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                        <input id="field-to_address" name="address" type="text" class="form-control" v-model="cart.to_address" required>
                        <small class="text-muted"></small>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="field-to_city">Billing city <span class="text-danger" v-tippy content="This field is required.">*</span> </label>
                        <input id="field-to_city" name="city" type="text" class="form-control" v-model="cart.to_city" required>
                        <small class="text-muted"></small>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="field-to_state">Billing state <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                        <select id="field-to_state" name="state" class="form-control" v-model="cart.to_state" required>
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="DC">District Of Columbia</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </select>
                        <small class="text-muted"></small>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="form-group">
                        <label for="field-to_zip_code">Billing zip code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                        <input id="field-to_zip_code" name="zip_code" type="text" class="form-control" v-model="cart.to_zip_code" required>
                        <small class="text-muted"></small>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <div class="row">
                    <div class="col-sm-12 mb-3">
                      <label for="card-number" class="d-block">Card number <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                      <div id="card-number" class="form-control" style="padding-top: 0.6rem !important"></div>
                    </div>
                    <div class="col-sm-6 mb-3">
                      <label for="card-expiry" class="d-block">Expiration date <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                      <div id="card-expiry" class="form-control" style="padding-top: 0.6rem !important"></div>
                    </div>
                    <div class="col-sm-6 mb-3">
                      <label for="card-cvc" class="d-block">CVC code <span class="text-danger" v-tippy content="This field is required.">*</span></label>
                      <div id="card-cvc" class="form-control" style="padding-top: 0.6rem !important"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="cart.status == 2 && cart.total > 0" class="pt-2">
              <div class="mt-2">
                <p-check class="p-default p-curve p-smooth" color="success" v-model="agree_terms" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I agree to {{app_name}}'s terms of service. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
              </div>
              <div class="mt-2">
                <p-check class="p-default p-curve p-smooth" color="success" v-model="not_refundable" required v-tippy content="Our 'Privacy Policy', 'Terms & Conditions' and 'Refund & Cancellation Policy' can be viewed at the very bottom of any page.">I understand that all sales are final and not refundable. <span class="text-danger" v-tippy content="This field is required.">*</span></p-check>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="modal-footer modal-footer-custom">
        <div class="mr-auto">
          <div class="d-print-none">
            <button type="button" class="btn btn-light mr-3 ml-0" :disabled="dsbl_btn" @click="$emit('closemodal')"><Icon icon="ri:close-fill" /> Close</button>
            <button type="button" :target="'print_invoice'" class="btn btn-light mr-3 ml-0 print_target" :disabled="dsbl_btn"><Icon icon="ri:printer-line" /> Print</button>
            <button v-if="cart.status == 1 && cart.id" type="button" class="btn btn-danger mr-3 ml-0" :disabled="dsbl_btn" @click="delete_cart()">
              <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
              <Icon v-show="!dsbl_btn" icon="ri:delete-bin-7-line" /> 
              Delete
            </button>
            <button v-if="cart.status == 2" type="button" class="btn btn-danger mr-3 ml-0" :disabled="dsbl_btn" @click="void_cart()">
              <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
              <Icon v-show="!dsbl_btn" icon="ri:delete-bin-7-line" /> 
              Void
            </button>
          </div>
        </div>

        <div v-if="cart.status == 0">

        </div>

        <div v-else-if="cart.status == 1 && !cart.id">
          <button type="button" class="btn btn-purple ml-3" :disabled="dsbl_btn" @click="create_cart()">
            <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!dsbl_btn" icon="ri:save-line" /> 
            Create draft
          </button>
        </div>

        <div v-else-if="cart.status == 1">
          <button type="button" class="btn btn-purple ml-3" :disabled="dsbl_btn" @click="save_cart()">
            <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!dsbl_btn" icon="ri:save-line" /> 
            Save changes
          </button>
          <button type="button" class="btn btn-warning ml-3" :disabled="dsbl_btn" @click="complete_cart()">
            <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!dsbl_btn" icon="ri:check-fill" /> 
            Complete invoice
          </button>
        </div>

        <div v-else-if="cart.status == 2">
          <button type="button" class="btn btn-warning ml-3" :disabled="dsbl_btn" @click="send_invoice()">
            <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!dsbl_btn" icon="ri:mail-send-line" /> 
            Send invoice
          </button>
          <button type="button" class="btn btn-success ml-3" :disabled="dsbl_btn" @click="submit_payment()">
            <span v-show="dsbl_btn" class="spinner-border spinner-border-sm"></span>
            <Icon v-show="!dsbl_btn" icon="ri:check-fill" />
            Submit payment
          </button>
        </div>

        <div v-else-if="cart.status == 3">
          <!-- <button type="button" class="btn btn-success ml-3" :disabled="dsbl_btn">Submit payment</button> -->
        </div>

      </footer>
    </div>

    <div v-show="tabIndex == 1">
      <div v-if="cart.id && communications_filters.onable_id && communications_filters.onable_type" class="p-3 bg-gray-100">
        <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'for_address'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
      </div>
      <footer class="modal-footer modal-footer-custom">
        <div class="mr-auto">
          <div class="d-print-none">
            <button type="button" class="btn btn-light mr-3 ml-0" :disabled="dsbl_btn" @click="$emit('closemodal')"><Icon icon="ri:close-fill" /> Close</button>
          </div>
        </div>
      </footer>
    </div>

    <div v-show="tabIndex == 2">
      <div v-if="cart.id" class="p-3 bg-gray-100">
        <pre class="card-box">{{cart}}</pre>
      </div>
      <footer class="modal-footer modal-footer-custom">
        <div class="mr-auto">
          <div class="d-print-none">
            <button type="button" class="btn btn-light mr-3 ml-0" :disabled="dsbl_btn" @click="$emit('closemodal')"><Icon icon="ri:close-fill" /> Close</button>
          </div>
        </div>
      </footer>
    </div>



  </div>
</template>
